<template>
  <div class="relative">
    <pict block-name="book-cover" :default="sources.default" :sources="sources.sources" :alt="alt" />
    <div
      v-if="displayDownloadButton"
      class="hidden m:flex absolute top-0 left-0 w-full h-full items-center justify-center opacity-0 hover:opacity-100"
    >
      <a
        :href="`${sources.default.src}?download=1`"
        class="text-blue bg-white opacity-95 px-12 py-4 rounded flex items-center justify-center gap-2"
      >
        <download-icon class="w-6 h-6" />
        {{ $t("download") }}
      </a>
    </div>
  </div>
</template>

<script>
import Pict from "@/shared/pict"
import DownloadIcon from "@/component-library/icons/download-icon"

export default {
  name: "BookCover",
  components: {
    Pict,
    DownloadIcon
  },
  props: {
    sources: { type: Object, default: () => ({}), required: true },
    alt: {
      type: String,
      default: ""
    },
    displayDownloadButton: {
      type: Boolean,
      default: false
    }
  },
  i18n: {
    messages: {
      en: {
        download: "Download image"
      },
      de: {
        label: "Download image"
      },
      es: {
        download: "Descargar imagen"
      }
    }
  }
}
</script>

<style lang="scss">
.book-cover {
  &__image {
    display: block;
    width: 100%;

    border-radius: $border-radius-4;
  }
}
</style>
